import { useCallback, useEffect, useState } from "react";
import { ITaskSingle } from "../types";
import WorkTasksService from "../../../services/workTasks";
import { useSetForm } from "./useSetForm";
import { FormInstance } from "antd";

export const useFetchById = (id: string, form: FormInstance, receipients?: boolean) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const { setForm, data } = useSetForm(form);

  const fetchData = useCallback(async () => {
    try {
      const res: ITaskSingle = await WorkTasksService.fetchOne(id, receipients ? { includeRecipients: true } : null);

      setIsLoading(false);

      setForm(res);
    } catch {
      setIsLoading(false);
    }
  }, [id, setForm, receipients]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { isLoading, data };
};
